module.exports = __webpack_public_path__ + "static/media/21.eclipse.84a29a92.svg";